import { post } from './client';
import { API_ENDPOINTS } from '../config/api';

export interface NotificationItem {
  id: number;
  title: string;
  body: string;
  type: 'system' | 'app';
}

interface NotificationListResponse {
  error?: { type?: string; message?: string };
  notifications: NotificationItem[];
}

interface NotificationReadResponse {
  error?: { type?: string; message?: string };
  success: boolean;
}

export async function getNotifications(loginKey: string) {
  return post<NotificationListResponse>(API_ENDPOINTS.NOTIFICATION_LIST, {
    login_key: loginKey,
  });
}

export async function markNotificationRead(loginKey: string, notificationId: number) {
  return post<NotificationReadResponse>(API_ENDPOINTS.NOTIFICATION_READ, {
    login_key: loginKey,
    notification_id: Number(notificationId),
  });
}

export default { getNotifications, markNotificationRead };
